import { createSelector } from 'reselect'

import { getRequestStatus } from '@cinch/oxd-utils/request-status/src'
import { ProfileReducer } from '../reducers/domain'

const getUpdateStatus = (state: { profile: ProfileReducer }) => state.profile && state.profile.updateStatus
const getFetchStatus = (state: { profile: ProfileReducer }) => state.profile && state.profile.fetchStatus

export default createSelector(getUpdateStatus, getFetchStatus, (update, fetch) => ({
  updateStatus: getRequestStatus(update),
  fetchStatus: getRequestStatus(fetch),
}))
